// extracted by extract-css-chunks-webpack-plugin
module.exports = {"emptyCartIcon":"empty-cart__emptyCartIcon__3p3UC"};